import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconVisa = createIcon({
  viewBox: '0 0 32 24',
  path: (
    <>
      <defs>
        <path
          id="prefix__a"
          d="M0.005 0.001L3.211 0.001 3.211 6.254 0.005 6.254z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H32V24H0z" />
        <g transform="translate(1 2)">
          <rect width="30" height="20" fill="#F4F4F5" rx="2" />
          <g>
            <path
              fill="#0E1A65"
              d="M5.122 6.007c-.041.118-.095.232-.142.348-.006.014-.015.019-.03.018H3.322c-.018 0-.04.011-.056-.01.022-.021.049-.015.074-.015h.65c.066 0 .068-.002.044-.066-.118-.311-.238-.622-.358-.934L2.86 3.222c-.195-.51-.39-1.02-.587-1.53L1.708.219c-.03-.077-.03-.077-.112-.077-.078 0-.156-.001-.234.002-.188.001-.376.002-.564 0-.232.003-.463 0-.694 0C.082.145.059.146.042.128.059.117.078.122.096.122h2.643c.039 0 .078-.002.116.006.03.013.035.042.045.068.146.377.29.756.435 1.134l.443 1.155c.047.125.098.25.144.376.026.09.038.181.055.272l.225 1.2c.002.009.004.017.014.025l.118-.285c.006-.007.004-.017.01-.023.043-.002.047.036.058.062l.21.549c.149.388.299.776.446 1.165.023.06.054.116.064.18"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M13.481 5.91c-.063.055-.135.096-.207.138-.124.073-.255.134-.39.185-.008.004-.017.005-.026.007.035-.064-.002-.119-.023-.175-.134-.356-.273-.71-.407-1.065-.008-.021-.023-.039-.027-.06l.074-.076c.156-.176.161-.425.013-.608-.05-.063-.11-.114-.175-.162-.083-.062-.171-.115-.261-.166-.018-.01-.037-.016-.051-.032.008-.024 0-.047-.008-.07l-.578-1.504L10.854.86c-.004-.01-.007-.02-.008-.032.052-.065.115-.12.178-.173.16-.134.335-.243.523-.332l.021-.006c.032 0 .036.028.044.049.144.378.291.756.434 1.135.017.045.053.085.045.139-.03.057-.06.114-.066.18-.012.104.02.195.084.277.052.068.117.122.185.172l.076.055c.017.02.028.043.037.067.363.938.72 1.878 1.082 2.816l.182.478c.007.019.017.037.012.059v-.001c-.007 0-.01.005-.012.012v-.001c-.006 0-.01.005-.012.012l.001-.002c-.006.002-.01.006-.012.012-.005.001-.009.005-.012.01l-.011.01c-.004.004-.008.008-.012.01v.001c-.01.01-.025.013-.031.026V5.83c-.006.001-.01.006-.012.011-.005.002-.008.006-.012.01-.01.009-.025.012-.032.025l.001-.001c-.006 0-.01.005-.013.01-.004.002-.008.007-.012.01-.006.007-.018.005-.02.015"
              transform="translate(5 7)"
            />
            <path
              fill="#00268F"
              d="M15.467 3.361c.017-.059.045-.113.068-.17l.534-1.275c.007-.015.01-.032.022-.044.008-.006.007-.016.01-.024.046-.001.05.039.06.067l.212.55c.16.415.316.83.479 1.244.004.01.008.021.008.032-.008.083-.05.154-.074.232-.014.042-.028.084-.046.125-.016.038-.001.048.036.05.068.002.137-.011.204.008.04.044.049.102.07.155.134.35.27.7.401 1.051.009.022.04.053-.007.072H16.31c-.034.002-.041-.025-.05-.049-.143-.381-.292-.76-.437-1.14-.105-.274-.21-.547-.313-.82-.01-.026-.026-.045-.044-.064"
              transform="translate(5 7)"
            />
            <path
              fill="#0F1961"
              d="M1.377.13c.092-.001.185-.001.277-.003.027 0 .039.01.048.036.053.141.109.282.163.423l.275.713c.091.24.18.48.272.72l.239.613c.092.24.18.48.273.72.078.205.16.409.238.614.092.24.18.48.273.72.085.221.173.443.258.665.074.19.145.383.218.574l.14.362c.008.022.013.045.023.076h-.809c-.033-.088-.05-.181-.074-.272L1.966 1.355l-.035-.133c-.003-.01-.002-.02-.01-.028-.01-.008 0-.025-.012-.032-.004-.007-.003-.017-.01-.023-.006-.006-.004-.016-.01-.023-.007-.006-.005-.016-.012-.022-.006-.006-.004-.017-.012-.022v.001c-.005-.007-.003-.018-.013-.022v.002c0-.007-.004-.01-.009-.014-.008-.01-.012-.025-.024-.032h.001c-.001-.006-.006-.01-.011-.012C1.808.99 1.804.988 1.8.984l-.011-.01L1.777.96C1.773.957 1.77.953 1.765.951 1.762.946 1.758.942 1.753.939L1.622.85c-.06-.191-.14-.376-.211-.564L1.374.187C1.367.167 1.36.148 1.377.13"
              transform="translate(5 7)"
            />
            <path
              fill="#071E72"
              d="M7.677 2.98c-.002-.003-.001-.005.002-.008.011-.013 0-.032.01-.046-.002-.003-.002-.006.002-.01.008-.01.002-.024.008-.035.042 0 .046.038.057.064.059.146.113.294.17.44l.463 1.208c.112.294.226.587.337.882.01.026.019.052.01.08-.008.084-.032.164-.049.245-.035.174-.073.347-.11.52l-.01.031c-.011.023-.032.017-.05.017-.133 0-.266-.002-.399 0-.04.002-.056-.017-.068-.05l-.464-1.211c-.072-.189-.142-.378-.218-.564-.007-.017-.019-.033-.014-.053.013-.102.04-.203.062-.304.079-.376.16-.751.24-1.127l.013-.042c.008-.011.001-.025.008-.036"
              transform="translate(5 7)"
            />
            <path
              fill="#002794"
              d="M16.85 3.743c-.111-.284-.223-.569-.332-.854l-.328-.862c-.017-.044-.036-.088-.052-.133-.007-.021-.018-.036-.037-.046.016-.059.044-.113.068-.17L16.625.59c.04-.094.09-.182.168-.25.034.002.038.032.048.054.023.055.042.11.063.166l.153.397.158.414.153.397.068.176.035.086c.016.02.004.039-.002.058l-.458 1.262-.12.334c-.008.023-.01.052-.042.06"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.683 5.743c-.043-.082-.07-.171-.103-.257-.065-.164-.128-.33-.191-.496l-.186-.486c-.06-.155-.12-.31-.178-.464l-.158-.414-.154-.398-.157-.413-.154-.398-.032-.094c.278.17.574.306.855.47.088.052.176.102.256.165.019.019.028.043.038.067.231.596.457 1.195.688 1.791.006.015.018.03.007.047-.014.083-.046.16-.078.236-.098.238-.243.444-.427.623-.008.008-.017.014-.026.02"
              transform="translate(5 7)"
            />
            <path
              fill="#02207A"
              d="M8.189.59c.008-.08.031-.157.046-.236.013-.068.03-.136.044-.204C8.28.14 8.28.13 8.29.128c.014-.01.029-.006.043-.006.23 0 .46.001.69-.001.045 0 .065.017.08.058.154.412.316.822.47 1.235.012.03.037.056.028.093-.013.1-.04.199-.06.298L9.245 3.19l-.011.037c-.011.014 0 .032-.01.045-.032.002-.039-.024-.047-.045l-.573-1.494L8.202.687C8.19.656 8.178.625 8.19.591"
              transform="translate(5 7)"
            />
            <path
              fill="#01217F"
              d="M10.846.827c.03.016.03.05.041.075.075.19.148.382.221.573l.183.48.272.707.217.574.18.464.058.15c.008.02.013.04-.017.046-.004-.008-.016-.006-.022-.012-.005-.007-.016-.005-.022-.01-.005-.008-.016-.006-.022-.012-.005-.007-.016-.005-.022-.012-.006-.006-.016-.004-.022-.01v-.001c-.006-.006-.016-.004-.022-.011-.005-.005-.01-.01-.017-.01-.17-.074-.332-.16-.49-.255-.208-.124-.402-.265-.572-.438-.19-.195-.333-.418-.405-.684-.046-.172-.052-.348-.036-.523.03-.338.145-.644.347-.916.01-.015.02-.032.036-.042.012-.007.016-.022.025-.032.004-.004.008-.008.01-.013v.001c.005-.003.01-.007.011-.013v.001c.005-.002.01-.006.01-.013v.001c.015-.01.024-.027.036-.042l.01-.011c.005-.004.009-.007.012-.012z"
              transform="translate(5 7)"
            />
            <path
              fill="#051F75"
              d="M8.736 5.556c-.012-.068-.045-.129-.069-.193-.06-.164-.124-.327-.187-.491L8.3 4.407l-.158-.414-.153-.397-.162-.424c-.03-.08-.06-.159-.092-.238-.008-.02-.015-.042-.038-.052.014-.103.04-.203.061-.303l.188-.876c.002-.01.006-.02.01-.03.042-.04.066-.036.09.018.045.104.082.21.123.316l.517 1.348c.094.247.19.493.283.741.014.04.038.074.054.112.002.003.002.007-.002.01-.008.011-.003.026-.008.038l.001.003-.002.003c-.013.014-.001.033-.01.048.001.003 0 .005-.002.007-.012.014 0 .033-.01.047.002.003.001.006-.002.01-.008.01-.003.025-.009.038l.002.003-.003.002c-.012.014 0 .034-.01.048.002.003.002.006-.002.008-.011.014 0 .032-.01.046.002.004.002.007-.001.01-.008.011-.003.026-.01.038l.002.003-.002.003c-.013.014-.001.033-.01.048-.009.083-.032.163-.049.244-.046.222-.094.443-.142.665-.002.01-.002.019-.01.026"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M15.467 3.361c.02-.01.031-.001.039.017.017.043.035.085.051.129l.293.77c.097.253.197.505.294.758l.148.393c-.014.011-.031.004-.047.006-.02 0-.01.02-.02.028-.03.105-.071.206-.108.308-.066.187-.134.373-.201.559-.02.053-.013.044-.061.044h-1.606l-.038-.003-.002-.003c0-.002.002-.004.003-.005.02-.016.044-.017.068-.017.17 0 .34-.002.509 0 .296.004.592.001.888.002.057 0 .062-.008.04-.063l-.351-.918-.3-.783c-.017-.045-.04-.088-.055-.133.025-.078.06-.151.092-.226.114-.275.23-.55.345-.824.005-.013.008-.029.02-.039"
              transform="translate(5 7)"
            />
            <path
              fill="#00299B"
              d="M19.615 4.54c-.023-.014-.037-.033-.047-.059l-.22-.573-.236-.609-.163-.43-.144-.37-.158-.414-.186-.486-.19-.496-.176-.46-.177-.465c-.018-.05-.017-.05-.07-.05L17.31.125c.017-.008.036-.004.054-.004H18.654c.042 0 .042 0 .05.04l.11.526c.11.524.22 1.047.328 1.57l.318 1.52.15.718c.003.014.007.029.005.044"
              transform="translate(5 7)"
            />
            <path
              fill="#0B1B69"
              d="M4.543 3.546c.03-.098.073-.192.11-.288l.315-.797c.006-.015.009-.032.021-.044.039-.001.041.032.05.056.084.207.162.417.242.626l.48 1.252c.01.029.028.057.017.09-.023.076-.058.147-.088.22l-.336.801c-.006.016-.014.03-.022.045-.006.006-.004.016-.01.022-.03.003-.034-.023-.042-.042l-.397-1.038-.332-.86c-.005-.014-.013-.027-.008-.043"
              transform="translate(5 7)"
            />
            <path
              fill="#002794"
              d="M16.236 5.429h1.223c.022-.02.049-.015.074-.015h.533c.064-.001.069-.008.045-.069l-.42-1.098c-.012-.029-.031-.057-.01-.09.048-.021.098-.009.147-.01.044-.003.089 0 .133-.001.055-.002.06-.007.049-.064l-.09-.432c-.008-.04-.02-.08-.02-.12 0-.017.001-.033-.004-.05l-.003-.015c-.002-.012-.004-.024-.008-.036l-.004-.021c-.001-.012-.003-.023-.007-.035-.002-.004-.003-.009-.003-.013-.002-.014-.004-.028-.008-.041l-.004-.014c-.001-.014-.003-.028-.007-.042l-.004-.013c-.001-.014-.003-.028-.007-.042l-.004-.013c-.001-.012-.004-.023-.008-.034l-.004-.02c0-.012-.003-.023-.007-.034l-.003-.014c-.002-.014-.003-.028-.008-.041l-.003-.014c-.002-.014-.003-.028-.008-.041l-.003-.014c-.002-.014-.003-.028-.008-.041l-.003-.014c-.002-.011-.004-.023-.008-.034-.002-.006-.004-.013-.004-.02-.001-.012-.004-.023-.007-.034l-.004-.014c-.001-.014-.003-.028-.007-.04l-.004-.015c-.001-.014-.003-.027-.007-.04l-.004-.014c-.001-.014-.002-.028-.007-.04l-.003-.014-.006-.033c0-.004.001-.009.004-.012.026-.013.028.011.033.023l.078.201.217.563.218.575.18.464.161.424.147.383.158.413c.05.133.102.265.153.398l.11.286c-.012.018-.026.014-.038.014h-.584c-.019 0-.037 0-.053-.01-.029-.102-.046-.206-.068-.309-.04-.188-.08-.376-.118-.564-.005-.028-.014-.04-.045-.04l-2.037.002c-.003-.003-.004-.005-.004-.008l.003-.004"
              transform="translate(5 7)"
            />
            <path
              fill="#071E72"
              d="M6.602 2.476c.001.003 0 .006-.003.007-.034-.007-.034-.04-.044-.064-.143-.367-.282-.736-.424-1.103L5.82.502C5.806.467 5.777.436 5.79.394c.028-.09.066-.175.102-.262 0-.002.005-.003.008-.005.033-.01.066-.005.099-.005.194 0 .388.002.582-.001.049-.001.07.017.085.058.116.312.24.621.355.933.025.065.06.126.07.197l-.009.03c-.15.362-.302.722-.453 1.083-.004.01-.005.022-.016.028-.008.007-.006.018-.01.026"
              transform="translate(5 7)"
            />
            <path
              fill="#02207A"
              d="M11.34 6.463c-.107.007-.214-.006-.32-.015-.203-.018-.404-.046-.604-.086l-.037-.011c-.03-.035-.036-.08-.052-.121-.141-.363-.277-.728-.42-1.09-.004-.012-.013-.023-.007-.037.015-.111.045-.22.068-.333l.257.116c.23.101.469.18.717.223.01.002.018.006.026.009.018.006.031.016.039.036.155.411.312.822.471 1.232.006.014.01.028.012.043.001.024-.005.04-.034.039-.038-.003-.077.005-.116-.005"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M9.024 4.208c-.025-.015-.04-.034-.051-.064-.055-.153-.116-.303-.174-.454l-.162-.424-.144-.376-.159-.413-.15-.392-.138-.361-.008-.02c-.023-.055-.023-.055-.081-.032.012-.097.038-.192.058-.287.054-.259.11-.516.165-.774.002-.007.006-.014.009-.02-.004.049.027.087.043.13.054.148.112.296.169.444l.143.371.164.429.147.382.158.413.155.402.022.062c.007.02.013.04.034.049-.012.099-.039.195-.059.293-.042.207-.088.414-.132.622-.002.007-.006.013-.009.02"
              transform="translate(5 7)"
            />
            <path
              fill="#0A1C6E"
              d="M6.445 2.85c-.023.074-.057.144-.087.216l-.236.563c-.006.015-.009.032-.022.044-.034-.01-.04-.041-.05-.068l-.334-.87-.381-.994c-.012-.029-.022-.059-.047-.08.005-.034.022-.063.034-.094L5.6.861c.006-.015.009-.032.021-.045.007-.006.006-.016.01-.024.04-.012.04.025.049.045.06.151.118.304.176.456.156.406.311.813.468 1.219.037.097.072.194.112.29.006.015.012.031.008.048"
              transform="translate(5 7)"
            />
            <path
              fill="#00248A"
              d="M15.011 4.45c.03.013.036.042.045.067.112.287.222.574.332.862l.328.863c.014.036.03.071.038.108l-.003.007-.005.002c-.314.007-.629.002-.943.003-.038-.046-.047-.103-.068-.156-.062-.16-.124-.319-.184-.48-.01-.025-.02-.051-.048-.064.04-.115.092-.225.138-.337l.349-.831c.006-.015.01-.032.021-.044"
              transform="translate(5 7)"
            />
            <path
              fill="#0A1C6C"
              d="M5.288 1.66c.03-.014.035.012.042.03.027.066.052.133.078.2.093.24.187.481.278.723.101.27.205.54.311.81.024.06.047.12.067.182.009.025.023.046.036.068-.02.07-.054.136-.082.204-.071.174-.145.347-.218.52-.006.015-.009.032-.022.044l-.12-.32-.19-.495c-.06-.153-.118-.306-.177-.46l-.158-.412-.114-.299c-.006-.015-.013-.031-.03-.038.028-.092.068-.179.103-.268.053-.14.109-.277.164-.416l.023-.05c.006-.006.004-.016.01-.023z"
              transform="translate(5 7)"
            />
            <path
              fill="#01217F"
              d="M12.401 4.94c.017.008.028.021.035.04l.267.702c.057.15.114.3.173.449.014.035.03.067-.01.095-.004.002-.006.01-.008.014-.01.01-.025 0-.033.012-.01.009-.025 0-.034.012h.001c-.007.004-.016.003-.023.008l-.004.003h-.005c-.007.004-.017.003-.024.008-.121.047-.247.075-.373.101-.097.02-.194.042-.294.046-.05-.091-.079-.191-.116-.288-.115-.294-.229-.59-.34-.886-.02-.052-.047-.075-.102-.069-.03.004-.06.003-.089 0-.017-.002-.04.003-.042-.024.103 0 .207.002.31-.002.177-.007.349-.04.512-.11.04-.017.08-.037.12-.057.024-.012.051-.022.068-.046l-.002.001c.007 0 .01-.005.014-.01z"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M12.09 1.639c-.097-.227-.18-.459-.267-.689L11.62.43c-.015-.038-.02-.082-.052-.114.104-.057.216-.094.327-.132.14-.047.283-.081.428-.11l.044-.003c.028-.005.027.02.033.035.148.382.293.764.44 1.146.008.02.025.044-.004.064-.11.014-.221.023-.328.056-.098.029-.191.068-.275.127-.055.04-.1.088-.142.14"
              transform="translate(5 7)"
            />
            <path
              fill="#00248B"
              d="M12.91.014c.095-.013.19-.008.286-.005.135.004.269.014.402.031.017.002.033.007.049.01.042.068.06.146.09.22l.454 1.184c.008.02.02.04.02.063.003.03-.008.047-.042.033-.006-.007-.016-.006-.024-.01h.001c-.007-.013-.024-.002-.032-.012-.007-.007-.018-.006-.026-.01h-.004l-.004-.003c-.007-.005-.016-.004-.023-.009-.007-.012-.023-.002-.033-.012-.007-.007-.018-.006-.027-.01-.087-.024-.174-.05-.26-.073-.105-.027-.21-.048-.316-.063-.01-.001-.021-.006-.032-.009.042-.014.046-.037.03-.08-.146-.375-.29-.75-.433-1.127-.017-.045-.03-.092-.076-.118"
              transform="translate(5 7)"
            />
            <path
              fill="#01217D"
              d="M11.38 5.163c.015.016.034.01.052.01h.133c.022 0 .033.007.04.028l.099.252.186.485.161.423c.008.022.019.044.018.069l-.003.002-.003-.002c-.023.01-.05-.002-.072.01-.006.003-.012.004-.019.001-.03.012-.062-.003-.092.01-.176.02-.353.025-.53.017-.003 0-.006-.003-.01-.005h.1c.04-.002.046-.01.032-.048-.022-.063-.047-.124-.07-.186l-.21-.548c-.06-.153-.119-.306-.177-.46-.009-.022-.019-.044-.023-.067-.003-.017-.015-.025-.024-.036l.175.022.237.023"
              transform="translate(5 7)"
            />
            <path
              fill="#002389"
              d="M12.91.014c.035-.004.053.016.065.047l.117.31.155.402.157.412.045.114c.012.032.01.037-.026.04h-.034l-.004.002-.005-.003c-.023-.012-.05.001-.072-.01-.065.004-.128-.01-.192-.01l-.28-.002c.01-.017.002-.033-.003-.048-.06-.153-.12-.305-.178-.458-.062-.161-.122-.323-.186-.484-.034-.085-.06-.174-.102-.255.05-.018.1-.02.152-.027.13-.017.26-.033.39-.03"
              transform="translate(5 7)"
            />
            <path
              fill="#0D1B67"
              d="M4.543 3.546c.036.047.047.104.068.157.072.183.142.368.213.552l.162.424.144.376.164.429c.007.017.007.037.029.045-.02.067-.051.13-.079.194-.04.095-.075.192-.122.284-.028-.035-.04-.079-.056-.12l-.19-.495-.155-.408-.153-.397c-.056-.145-.11-.29-.167-.434-.014-.037-.016-.08-.057-.103.028-.094.069-.183.104-.274.03-.077.057-.156.095-.23"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.17 1.55c.034-.01.038-.014.027-.042-.026-.07-.053-.138-.08-.206l-.17-.444-.2-.521-.093-.249c-.004-.012-.008-.025-.007-.038.094.005.186.026.279.045.21.043.416.102.618.175.042.016.042.016.032.06l-.264 1.236-.011.04c-.047-.015-.09-.033-.132-.056"
              transform="translate(5 7)"
            />
            <path
              fill="#0D1B67"
              d="M3.922 2.861c-.064-.094-.092-.204-.133-.307-.067-.166-.13-.334-.193-.5l-.185-.487-.18-.464-.155-.408-.155-.403C2.9.238 2.883.181 2.855.128c.095.002.182.03.265.072.218.11.349.29.401.524.043.191.075.385.112.578l.217 1.156.07.37c.002.011.002.022.002.033"
              transform="translate(5 7)"
            />
            <path
              fill="#091E6F"
              d="M6.445 2.85c-.046-.089-.076-.184-.112-.277-.052-.132-.102-.265-.153-.397l-.159-.414-.153-.397L5.702.93 5.656.812c-.005-.013-.013-.017-.025-.02.026-.086.064-.167.097-.251.019-.05.034-.1.061-.147.037.093.075.185.11.277l.19.491.178.465c.054.142.107.284.162.424.056.144.106.291.17.432-.047.124-.097.247-.154.367"
              transform="translate(5 7)"
            />
            <path
              fill="#01217D"
              d="M9.602 1.507c-.11-.246-.196-.5-.296-.75-.078-.194-.15-.392-.222-.589-.012-.032-.029-.041-.06-.041H8.29c.015-.01.033-.005.049-.005h1.505c.016 0 .033-.004.052.006-.004.054-.02.107-.03.16L9.61 1.486c-.001.007-.005.014-.008.02"
              transform="translate(5 7)"
            />
            <path
              fill="#051F75"
              d="M7.09 1.309c-.036-.05-.053-.11-.075-.166C6.912.875 6.811.605 6.71.337 6.688.28 6.663.224 6.643.167c-.01-.033-.03-.04-.06-.04h-.684c.018-.01.037-.005.055-.005H7.53c.018 0 .037-.005.053.006.002.014-.005.025-.01.037L7.107 1.28c-.005.01-.006.022-.016.029"
              transform="translate(5 7)"
            />
            <path
              fill="#0A1C6E"
              d="M7.244 5.005c-.002-.004-.001-.007.002-.01.046-.008.043.033.052.056.052.133.104.265.154.398.105.279.215.555.319.835l.01.026c.014.049.008.058-.045.058H7.07c-.038 0-.077.006-.115-.006.007-.085.031-.167.049-.25.072-.345.147-.69.22-1.035l.01-.026c.012-.014 0-.033.01-.046"
              transform="translate(5 7)"
            />
            <path
              fill="#091E6F"
              d="M6.955 6.362h.794c.028-.002.033-.009.022-.035l-.204-.532-.161-.423-.136-.351c-.005-.013-.008-.025-.024-.026.014-.1.04-.197.06-.296.015-.07.025-.14.048-.209.038.056.057.12.08.182l.154.397.158.413.186.486.133.346c.018.047.017.048.065.048h.383c.019 0 .037 0 .053-.01 0 .01 0 .019-.012.02l-.033.001H6.99c-.012 0-.03.01-.035-.01"
              transform="translate(5 7)"
            />
            <path
              fill="#002388"
              d="M14.214 4.863c-.116-.273-.214-.553-.322-.83-.111-.283-.22-.567-.329-.851l-.082-.224c.38.253.67.573.772 1.034.04.184.041.37.023.557-.01.097-.027.194-.052.289-.002.008-.007.017-.01.025"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M9.9 5.103c.044.061.06.134.088.202.112.287.223.574.331.862.023.06.053.118.06.184-.112-.016-.22-.047-.328-.078-.115-.032-.229-.07-.34-.117-.026-.011-.036-.024-.03-.054l.213-.99c0-.003.004-.006.006-.009"
              transform="translate(5 7)"
            />
            <path
              fill="#0F1961"
              d="M1.377.13c-.003.044.021.081.036.12.068.184.14.366.21.55.008.017.016.033-.001.05-.15-.076-.301-.148-.459-.206L.91.55C.925.522.915.497.905.47L.801.197C.793.175.779.153.799.13c.192-.004.385-.004.578 0"
              transform="translate(5 7)"
            />
            <path
              fill="#10195E"
              d="M.799.13c-.001.048.025.088.04.13.026.075.058.148.086.221C.93.495.932.51.936.524.946.552.926.548.91.55.9.539.885.549.876.539.78.509.682.48.584.452.405.402.224.354.042.315-.004.305-.006.304.006.257.017.214.015.167.042.127h.69C.755.128.777.13.8.13"
              transform="translate(5 7)"
            />
            <path
              fill="#002386"
              d="M14.503 5.662c.024-.014.036-.007.045.019.035.094.073.188.11.283l.139.366c.004.01.004.021.006.032h-.591c-.001-.012.004-.022.008-.032l.257-.611c.003-.009.004-.018.013-.024.01-.006.008-.017.011-.026-.002-.003 0-.006.002-.007"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M12.422 4.948c-.011.081-.055.092-.1.1.03-.04.063-.074.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#01217F"
              d="M11.88 6.532c.031-.167.066-.053.1-.075-.033.1-.066.085-.1.075"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.887.85c-.007.054-.04.088-.1.1.023-.042.056-.075.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#01217F"
              d="M11.99 6.522c.031-.163.067-.06.1-.079-.03.103-.065.088-.1.079"
              transform="translate(5 7)"
            />
            <path
              fill="#00248B"
              d="M13.308 1.342c.033.02.07-.086.1.08-.034.006-.069.021-.1-.08"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M9.228 3.328c.01-.034-.05-.072.091-.1.013.036.002.07-.09.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.819 1.007c.072.011.1.048.1.1-.05-.025-.081-.06-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F75"
              d="M7.772 2.926c-.008.035.053.073-.09.1-.01-.035-.004-.07.09-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M9.01 4.362c.004-.035-.057-.073.089-.1.006.035.006.07-.088.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.526 5.951c.01-.07.048-.098.1-.1-.023.05-.057.082-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.582 5.906c.01-.068.047-.094.1-.1-.023.05-.057.082-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#091E6F"
              d="M7.327 5.005c-.007.034.053.072-.09.1-.01-.036-.003-.07.09-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.832.928c-.003.053-.032.089-.1.1.02-.042.05-.078.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M8.945 4.673c.003-.035-.059-.073.087-.1.006.035.007.07-.087.1M8.964 4.573c.006-.035-.054-.073.089-.1.01.035.004.07-.09.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M8.978 4.517c.003-.034-.058-.073.088-.1.005.035.006.07-.088.1M8.997 4.417c.007-.034-.054-.072.09-.1.01.036.003.07-.09.1M8.955 4.629c-.005-.036-.043-.073.086-.1.012.036.01.07-.086.1M9.022 4.318c-.006-.036-.043-.073.085-.1.013.035.01.07-.085.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00268F"
              d="M16.322 5.429l.003.036c-.013.025-.039.048-.1.064.003-.037-.018-.076.097-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F77"
              d="M8.989 4.473c-.006-.035-.044-.073.085-.1.012.036.01.071-.085.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M12.825 6.34c.022-.117.062-.096.1-.1-.027.08-.062.104-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M12.791 6.352c.022-.123.063-.1.1-.098-.026.087-.062.097-.1.098"
              transform="translate(5 7)"
            />
            <path
              fill="#0F1961"
              d="M.876.539c.037.002.077-.02.1.098C.938.645.904.623.876.54"
              transform="translate(5 7)"
            />
            <path
              fill="#051F75"
              d="M7.76 2.98c.006.036.038.073-.086.1-.015-.036-.007-.07.087-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.024 1.495c.038.002.078-.02.1.1-.037.001-.072-.02-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#051F75"
              d="M7.775 2.881c.017.037.043.074-.079.1-.011-.036-.018-.071.08-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.909 1.162c.119.02.097.062.1.1-.078-.027-.098-.063-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.114 1.528c.037.004.08-.017.1.1-.038-.002-.074-.023-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.888 1.116c.084.023.101.06.1.1-.076-.023-.103-.058-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002794"
              d="M16.186 1.848c.014.042.003.079-.095.1-.001-.04.01-.077.095-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.899 1.139c.095.021.106.058.097.1-.083-.024-.099-.06-.097-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0A1C6E"
              d="M5.378 1.66c.003.04-.01.077-.097.1-.01-.04.017-.075.097-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.922 1.194c.104.024.105.061.095.1-.087-.025-.1-.061-.095-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0D1B67"
              d="M5.323 5.607c-.001-.04.014-.077.098-.1.01.041-.022.075-.098.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248A"
              d="M14.587 5.669c.009.04.004.079-.097.1.002-.04.017-.076.097-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.145 1.542c.041-.009.077.006.1.097-.04.005-.076-.01-.1-.097"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.481 5.995c.013-.072.053-.093.1-.1-.02.058-.055.088-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.088 1.52c.04-.008.077-.001.1.097-.04.005-.075-.012-.1-.097"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M14.057 1.507c.04-.005.076.008.1.097-.04.01-.075-.012-.1-.097"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M12.769 6.36c.024-.09.06-.103.1-.095-.025.088-.06.107-.1.095"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M12.736 6.37c.024-.096.061-.101.1-.093-.026.089-.061.107-.1.093"
              transform="translate(5 7)"
            />
            <path
              fill="#091E6F"
              d="M5.718.792c.012.041.002.078-.095.1-.005-.04.008-.076.095-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#00248C"
              d="M13.997 1.488c.039-.01.076-.01.1.095-.038.006-.074-.007-.1-.095"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.979 3.885c.043-.002.083.01.1.1-.042-.005-.079-.027-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.957 3.873c.043 0 .08.017.1.1-.042-.002-.078-.027-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0D1B67"
              d="M4.433 4.05c.004.04-.01.076-.097.1-.01-.041.014-.076.097-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.935 3.862c.042.002.08.02.1.1-.042 0-.077-.03-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.913 3.85c.042.004.08.022.1.1-.043.003-.076-.03-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.852 1.051c.088.012.1.054.1.1-.067-.02-.09-.058-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.891 3.84c.041.003.079.022.1.099-.043.004-.075-.032-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#091E6F"
              d="M6.604 2.55c-.008-.04-.001-.078.097-.1.001.04-.015.076-.097.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.87 3.828c.04.005.077.023.1.1-.044.004-.076-.033-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.865 1.072c.08.02.098.057.1.1-.069-.022-.097-.057-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.877 1.094c.08.021.098.059.1.1-.07-.024-.102-.057-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M11.852 3.819c.042.002.076.033.1.1-.044.003-.078-.026-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.799.983l.1.1c-.059-.012-.092-.045-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.502 5.985l.1-.1c-.014.064-.047.098-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.514 5.975c.018-.058.05-.092.1-.1-.015.063-.05.094-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.843 1.039c.062.02.096.052.1.1-.069-.016-.097-.052-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.809.995c.056.016.09.05.1.1-.06-.014-.092-.049-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.558 5.94l.1-.1c-.013.063-.047.096-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.57 5.93c.016-.057.049-.091.1-.1-.014.062-.05.093-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.613 5.896l.1-.1c-.012.06-.045.094-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.625 5.885l.1-.1c-.013.06-.046.093-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.636 5.874c.017-.053.05-.087.1-.1-.012.06-.046.092-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.648 5.863c.014-.055.048-.089.1-.1-.013.059-.047.091-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.66 5.853c.012-.058.045-.092.1-.1-.014.057-.048.09-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002385"
              d="M13.67 5.842c.01-.06.044-.093.1-.1-.012.057-.047.089-.1.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.935.827l-.1.1c.008-.056.041-.09.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.788.972l.1.1c-.058-.011-.091-.044-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.924.839l-.1.1c.007-.057.04-.09.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.777.961l.1.1c-.057-.01-.09-.043-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.877.891c-.005.053-.04.086-.1.1.01-.05.04-.086.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.867.903c-.01.05-.044.083-.1.1.008-.052.04-.086.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002282"
              d="M10.857.915l-.1.1c.006-.053.039-.087.1-.1M12.488 4.939c-.017.058-.05.091-.1.1.015-.063.05-.093.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.753.94l.1.1c-.053-.01-.086-.043-.1-.1"
              transform="translate(5 7)"
            />
            <path
              fill="#0E1A65"
              d="M1.765.95l.1.1c-.055-.009-.089-.042-.1-.1"
              transform="translate(5 7)"
            />
            <g transform="translate(5 7) translate(16.788 .12)">
              <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
              </mask>
              <path
                fill="#002898"
                d="M3.2 6.187l-.307-1.47c-.021-.1-.037-.2-.066-.297-.057-.098-.09-.207-.13-.312L1.95 2.163 1.465.893C1.358.61 1.245.33 1.142.045 1.131.014 1.112 0 1.077.001c-.065.003-.13 0-.195.001-.12.003-.24-.005-.36.005C.47 0 .418.007.368.019.228.051.103.111.005.22c.026.039.044.08.06.124.19.503.385 1.004.577 1.506.009.023.017.048.04.06.034-.063.048-.134.084-.209l.06.28.103.498c.001.007.005.014.008.02v.004c.014.009.018.025.024.04.1.255.198.51.296.766l.699 1.825.395 1.031c.023.062.021.064-.047.064h-.388c-.067 0-.133-.006-.2.004 0 .01.001.019.013.02.013.002.026.002.039.002h1.399c.014 0 .029.004.044-.008L3.2 6.187"
                mask="url(#prefix__b)"
              />
            </g>
            <path
              fill="#002793"
              d="M16.981 4.162l.138-.003h.507c.019 0 .037.002.055.003.005.056.033.105.052.156.07.189.143.376.216.563.06.157.12.313.182.469.028.072.024.079-.05.079h-.622c-.039-.122-.089-.239-.134-.357l-.157-.414-.166-.434c-.008-.02-.014-.041-.02-.062"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.937 3.306c-.094-.03-.094-.065-.087-.1.145.027.085.065.087.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.95 3.362c-.093-.03-.097-.065-.087-.1.142.027.083.065.088.1M17.908 3.15c-.092-.03-.101-.064-.089-.1.142.028.082.066.089.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.895 3.095c-.094-.03-.097-.065-.088-.1.143.027.083.065.088.1M17.964 3.417c-.093-.03-.101-.064-.09-.1.142.028.083.066.09.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.881 3.04c-.094-.03-.093-.066-.086-.1.145.027.084.064.086.1M17.993 3.573c-.094-.03-.095-.065-.087-.1.144.027.084.065.087.1M17.852 2.884c-.093-.03-.1-.065-.089-.1.142.027.082.065.089.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.839 2.828c-.095-.03-.097-.065-.088-.1.144.027.084.065.088.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.825 2.772c-.094-.03-.093-.064-.086-.1.145.028.084.066.086.1M17.983 3.528c-.094-.029-.098-.064-.084-.1.126.028.092.065.084.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.972 3.473c-.096-.03-.097-.064-.085-.1.129.027.091.064.085.1M17.928 3.262c-.095-.03-.098-.064-.085-.1.126.027.092.064.085.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.916 3.206c-.096-.029-.097-.064-.084-.1.128.027.09.065.084.1M17.872 2.995c-.095-.03-.098-.064-.084-.1.126.027.091.064.084.1M17.816 2.728c-.095-.029-.097-.064-.084-.1.127.027.091.065.084.1"
              transform="translate(5 7)"
            />
            <path
              fill="#002898"
              d="M17.861 2.94c-.098-.03-.097-.065-.085-.1.13.026.09.064.085.1"
              transform="translate(5 7)"
            />
          </g>
        </g>
      </g>
    </>
  ),
});

export default IconVisa;
